// import { css } from "@emotion/core";
import { rem } from "./utils";

export const mobile = `max-width: ${rem(650)}`;
export const desktop = `min-width: ${rem(651)}`;
